import { useQuery } from '@tanstack/react-query';
import { t } from 'i18next';
import { useSearchParams } from 'react-router-dom';

import {
  CURSOR_QUERY_PARAM,
  DataTable,
  LIMIT_QUERY_PARAM,
} from '@/components/ui/data-table';
import { TableTitle } from '@/components/ui/table-title';
import { AdminExecution, SeekPage } from '@activepieces/shared';
import { adminApi } from '@/features/internal-admin/lib/admin-api';
import { useAdminExecutionsTable } from '@/features/internal-admin/lib/admin-executions-table';

const AdminExecutionsPage = () => {
  const { columns, filters, openExecution } = useAdminExecutionsTable();
  const [searchParams] = useSearchParams();

  const queryParams = {
    cursor: searchParams.get(CURSOR_QUERY_PARAM) || undefined,
    limit: Number(searchParams.get(LIMIT_QUERY_PARAM)) || 10,
    search: searchParams.get('flowDisplayName') ?? undefined,
    externalId: searchParams.get('externalId') ?? undefined,
    externalCustomerId: searchParams.get('externalCustomerId') ?? undefined,
    status:
      searchParams.getAll('status').length > 0
        ? searchParams.getAll('status')
        : undefined,
    startTimeAfter: searchParams.get('startTimeAfter') ?? undefined,
    startTimeBefore: searchParams.get('startTimeBefore') ?? undefined,
  };

  const { data, isLoading, isError } = useQuery<
    SeekPage<AdminExecution>,
    Error
  >({
    queryKey: ['admin-executions', queryParams],
    queryFn: () => adminApi.listExecutions(queryParams),
  });

  if (isError) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-destructive">{t('Failed to load executions')}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full">
      <TableTitle>{t('Executions')}</TableTitle>
      <DataTable
        columns={columns}
        page={data}
        isLoading={isLoading}
        filters={filters}
        onRowClick={openExecution}
      />
    </div>
  );
};

export default AdminExecutionsPage;
